import api from "Helpers/Api";
import { TArticle } from "Services/Article/article";

export default async function articleFetch(slug: string) {
  const { data } = await api.get<TArticle>(`/articles/${slug}`);

  return data;
}
